<template>
    <div
        class="welcome-easy-swiper"
        ref="welcome-easy-swiper"
        :class="[rootClass, { isEditor }, isPcWebMode ? 'welcome-easy-swiper-pc' : '']"
        :style="rootStyle"
    >
        <div
            class="swiper"
            ref="swiper"
        >
            <div
                class="swiper-wrapper"
                :style="wrapperStyle"
            >
                <div
                    class="swiper-slide"
                    :key="'swiper-slide-' + index"
                    v-for="(item, index) in lazyList"
                    :style="{
                        backgroundImage: `url(${isEditor ? item.src : (item.n_src || '')})`,
                    }"
                >
                </div>
            </div>
            <!-- 指示器占比宽度与颜色 使用 css 变量控制 -->
            <div
                class="swiper-pagination"
                :class="[uuid]"
                :style="`--list-count: ${list && list.length};--activeColor: ${activeColor};--deactiveColor: ${deactiveColor}`"
            ></div>
        </div>
    </div>
</template>

<script>
import { isEditor, isPcMode } from '../fego/utils';
import Swiper, { Pagination, Autoplay } from "swiper";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/autoplay/autoplay.min.css";
import * as base from "@futuweb/tool-base";
import core from "./core.vue";




let judgeWebpUrl = (x)=>{
    return x
}

let lazyloadMixins = ()=>{
    return {}
}

if(window.FEGORender){
    judgeWebpUrl = window.FEGORender.common.utils.judgeWebp.judgeWebpUrl
    lazyloadMixins = window.FEGORender.common.utils.lazyload.mixins
}

export default {
    name: "welcome-easy-swiper",
    extends: core,
    props: {
        backgroundColor: {
            type: String,
            default: ''
        },
        list: {
            type: Array,
            default: () => []
        },
        slideWidth: {
            type: Number,
            default: 320,
        },
        slideHeight: {
            type: Number,
            default: 380
        },
        slideMargin: {
            type: Number,
            default: 30
        },
        activeColor: {
            type: String,
            default: '#ff6900'
        },
        deactiveColor: {
            type: String,
            default: '#9f9f9f'
        }
    },
    mixins: [
        lazyloadMixins()
    ],
    data() {
        return {
            isEditor,
            swiper: null,
            hasReached:false, //是否已经显示过了。避免不判断图片src
            tmpList:[],
            count: 0,
            // 一个页面加入多个轮播时，滚动条class相同会导致分页用的是同一个
            uuid: 'swiper-pagination-' + parseInt(Math.random() * 1000000)
        };
    },
    computed: {
        rootStyle() {
            if (this.backgroundColor) {
                return {
                    backgroundColor: this.backgroundColor
                };
            }
            return {};
        },
        /**
         * 设定 swiper-wrapper的样式
         */
        wrapperStyle() {
            const { slideWidth, slideHeight } = this.$props;
            return {
                width: `${this.setRem(slideWidth)}rem`,
                height: `${this.setRem(slideHeight)}rem`
            };
        },
        // 是否 web 端
        isPcWebMode() {
            return isPcMode();
        },
        lazyList(){
            if(this.isEditor)
                return this.list

            //首次进入显示区
            if(!this.hasReached && this.lazyloadHasReach){
                //只标记一次已显过
                this.hasReached = true;
                this.tmpList = this.list.map(x=>{
                    return Object.assign({}, x, {
                        n_src : judgeWebpUrl(x.src)
                    })
                })
            }
            return this.hasReached ? this.tmpList : this.list
        }
    },
    watch: {
        list: {
            handler(val) {
                this.swiper && this.swiper.destroy(true, false);
                this.init();
            },
            deep: true
        },
        lazyList:{
            handler(val){
                this.swiper && this.swiper.destroy(true, false);
                this.init();
            },
            deep:true
        },
        slideWidth(val) {
            this.swiper && this.swiper.destroy(true, false);
            this.init();
        },
        slideHeight(val) {
            this.swiper && this.swiper.destroy(true, false);
            this.init();
        },
        slideMargin(val) {
            this.swiper && this.swiper.destroy(true, false);
            this.init();
        }
    },
    beforeMount() {
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const vm = this; // swiper on 中 this 指向为 swiper 实例。
            const isCenter = this.isPcWebMode ? true : false;
            setTimeout(() => {
                let pageEl = ".swiper-pagination." + this.uuid;
                const swiper = new Swiper(this.$refs.swiper, {
                    modules: [Pagination, Autoplay],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: "auto",
                    loopedSlides: vm.$props.list.length,
                    spaceBetween: vm.$props.slideMargin,
                    centeredSlides: isCenter,
                    pagination: {
                        el: pageEl,
                        clickable: true
                    },
                    on: {
                        // FIX pagination 不同步的 BUG
                        slideChangeTransitionEnd(swiper) {
                            const realIndex = swiper.realIndex;
                            const paginations = document.querySelectorAll(pageEl + ">span");
                            Array.prototype.forEach.call(paginations, (item, idx) => {
                                if (idx === realIndex) {
                                    base.addClass(item, "swiper-pagination-bullet-active");
                                } else {
                                    base.removeClass(item, "swiper-pagination-bullet-active");
                                }
                            });
                        },
                        click(swiper) {
                            const listItemIndex = (swiper.clickedIndex) % vm.$props.list.length;
                            const listItem = vm.$props.list[listItemIndex];
                            if (listItem && listItem.link) {
                                location.href = listItem.link;
                            }
                        }
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                });
                this.swiper = swiper;
            });
        },
    },
    destroyed() {
    },
};
</script>

<style scoped lang="less">
@import "./common.less";
.welcome-easy-swiper {
    padding: .15rem 0;
    .swiper {
        width: 100%;
        height: 100%;
        padding-bottom: calc(0.3rem + 0.12rem);
        margin: auto;
        margin-left: .4rem;
        position: relative;
        z-index: 0; // 覆盖外部
        .swiper-wrapper {
            height: 100%;
        }
        .swiper-slide {
            background-size: 100% 100%;
            background-repeat: no-repeat;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: .3rem;
            box-shadow: 0 .28rem 20 0 rgba(0, 0, 0, .05);
        }
        .swiper-pagination {
            position: absolute;
            width: auto;
            left: -.4rem;
            right: .4rem;
            bottom: 0;
            display: flex;
            justify-content: center;
            /deep/ .swiper-pagination-bullet {
                width: .12rem;
                height: .12rem;
                border-radius: 50%;
                background-color: var(--deactiveColor);
                opacity: 1;
                margin: 0 .15rem 0 0;
            }
            /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
                background-color: #ff6900;
                background-color: var(--activeColor);
            }
        }
    }
}
// 在 editor 中禁用鼠标事件
.welcome-easy-swiper.isEditor {
    * {
        pointer-events: none;
    }
}
/** PC Web 端**/
.welcome-easy-swiper-pc {
    margin: 1.3rem 0;
    .swiper {
        margin-left: unset;
        padding-bottom: .4rem;
        .swiper-slide {
            border-radius: .2rem;
            box-shadow: 0 .1rem 20 0 rgba(0, 0, 0, .05);
        }
        .swiper-pagination {
            /deep/ .swiper-pagination-bullet {
                margin: 0 .2rem 0 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/render/index.vue